import { useAuth } from "../contexts/AuthContext"
import { db } from '../firebase'
import Cancel from '@material-ui/icons/Cancel';
import "../css/MatchInfo.css"

function MatchInfo(props) {

    const { currentUser } = useAuth()

    db.collection("Players").doc(`${currentUser.uid}`).collection("Bets").doc(`${props.id}`)
    .get()
    .then((doc) => {
        if (doc.exists) {
            let savebtn = document.getElementById("saveBetButton")
            savebtn.innerHTML = "Already betted on this match"
            savebtn.setAttribute('disabled', true);
        }
    })
    
    localStorage.setItem('TeamId', "not chosen yet");

    var docRef1 = db.collection("Players").doc(`${currentUser.uid}`).collection("Bets").doc(`${props.id}`)

    function onSaveBet() {

        if (localStorage.getItem('TeamId') !== "not chosen yet") {
            var betTeamId = parseInt(localStorage.getItem('TeamId'));
            var docRef2 = db.collection("Teams").doc(`${betTeamId}`)
            var betDrawOrTeam = "";

            console.log(localStorage.getItem('TeamId'))
            if (localStorage.getItem('TeamId') === "null") {
                betDrawOrTeam = "A DRAW"

                docRef1.set({
                    id: props.id,
                    teams: props.teams,
                    logoLocalTeam: props.logoLocalTeam,
                    localTeam: props.localTeam,
                    localTeamId: props.localTeamId,
                    visitorTeam: props.visitorTeam,
                    logoVisitorTeam: props.logoVisitorTeam,
                    visitorTeamId: props.visitorTeamId,
                    dateAndTime: props.dateAndTime,
                    date: props.date,
                    time: props.time,
                    timestamp: props.timestamp,
                    league: props.league,
                    predictionLocal: props.predictionLocal,
                    predictionVisitor: props.predictionVisitor,
                    predictionDraw: props.predictionDraw,
                    winnerTeamId: props.winnerTeamId,
                    isProcessed: props.isProcessed,
                    scoreIsAdded: false,

                    bet: null,
                    betDrawOrTeam: betDrawOrTeam,
                    bettedTimestamp: Date.now()
                })
                    .then(() => {
                        console.log("Document successfully written!");
                        props.onCancel();
                    })
                    .catch((error) => {
                        console.error("Error writing document: ", error);
                    });

            }
            else {
                docRef2.get().then((doc) => {
                    if (doc.exists) {
                        betDrawOrTeam = doc.data().name;

                        docRef1.set({
                            id: props.id,
                            teams: props.teams,
                            logoLocalTeam: props.logoLocalTeam,
                            localTeam: props.localTeam,
                            localTeamId: props.localTeamId,
                            visitorTeam: props.visitorTeam,
                            visitorTeamId: props.visitorTeamId,
                            logoVisitorTeam: props.logoVisitorTeam,
                            dateAndTime: props.dateAndTime,
                            date: props.date,
                            time: props.time,
                            timestamp: props.timestamp,
                            league: props.league,
                            predictionLocal: props.predictionLocal,
                            predictionVisitor: props.predictionVisitor,
                            predictionDraw: props.predictionDraw,
                            winnerTeamId: props.winnerTeamId,
                            isProcessed: props.isProcessed,
                            scoreIsAdded: false,

                            bet: betTeamId,
                            betDrawOrTeam: betDrawOrTeam,
                            bettedTimestamp: Date.now()
                        })
                            .then(() => {
                                console.log("Document successfully written!");
                                props.onCancel();
                            })
                            .catch((error) => {
                                console.error("Error writing document: ", error);
                            });
                    }
                })
            }
        }

        else {
            alert("You haven't chosen a bet, place a bet");
        }


    }

    function SaveTeamId(int) {

        if (int === 1) {
            localStorage.setItem('TeamId', props.localTeamId);
        }
        if (int === 2) {
            localStorage.setItem('TeamId', null);
        }
        if (int === 3) {
            localStorage.setItem('TeamId', props.visitorTeamId);
        }
    }

    return (

        <div className="text-center mb-3 me-4 bg-dark matchInfo">
            <div className="row card-header verticalAlign">
                <div className="col-md-4">
                    <p className="">{props.date}</p>
                </div>
                <div className="col-md-4">
                    <h5 className="">{props.teams} <br /> {props.league}</h5>
                </div>
                <div className="col-md-1 offset-md-3">
                    <button className="btn btn-dark" onClick={props.onCancel}>
                        <Cancel />
                    </button>
                </div>
            </div>
            <div className="card-body row">
                <div className="col-md-4">
                    <button className='btn btn-white btn-circle btn-xl mt-3' onClick={SaveTeamId.bind(this, 1)}>
                        <img src={props.logoLocalTeam} alt="football_team_local" width="80" height="80" />
                    </button>
                </div>
                <div className="col-md-4">
                    <button className='btn btn-white btn-circle btn-xl border border-light mt-3' onClick={SaveTeamId.bind(this, 2)}>
                        <p className="text-white" style={{ marginBottom: "0px" }}>
                            DRAW
                        </p>
                    </button>
                </div>
                <div className="col-md-4">
                    <button className='btn btn-white btn-circle btn-xl mt-3' onClick={SaveTeamId.bind(this, 3)}>
                        <img src={props.logoVisitorTeam} alt="football_team_local" width="80" height="80" />
                    </button>
                </div>

                <div className="col-md-4">
                    <p className="mt-1">{Math.round(props.predictionLocal)}%</p>
                </div>

                <div className="col-md-4">
                    <p className="mt-1">{Math.round(props.predictionDraw)}%</p>
                </div>

                <div className="col-md-4">
                    <p className="mt-1">{Math.round(props.predictionVisitor)}%</p>
                </div>

                <div className="offset-md-4 col-md-4">
                    <button className='btn btn-info mt-2' id="saveBetButton" onClick={onSaveBet}>SAVE BET</button>
                </div>



            </div>
        </div>
    )
};

export default MatchInfo;